export default __webpack_public_path__ + "c876221dd6f319d24969f90309d9a31a.png";